import { useColorable } from "@vividtheory/minerva-lab";
import { useEffect, useState } from "react";
import React from "react";
import { AvatarChip, AvatarGroup, Box, Button, CompanyAvatar, Divider, Grid, Menu, OverflowingTypography, Stack, Tag, UserAvatar, } from "../components";
import { ExpandMoreOutline, LogoutOutline, MatchCaseOutline } from "../icons";
export const ThemeOption = ({ mode }) => {
    const colorStyles = useColorable({
        color: "background",
        colorSet: "container",
        invertColors: mode === "dark",
    });
    return (React.createElement(Box, { width: 12, height: 7, sx: Object.assign({ paddingTop: 2, paddingLeft: 2, borderRadius: (theme) => theme.radius.default, border: 1, borderColor: (theme) => theme.palette.stroke[100] }, colorStyles) },
        React.createElement(Box, { width: "100%", height: "100%", sx: {
                borderTop: 1,
                borderLeft: 1,
                borderColor: (theme) => theme.palette.outline,
                borderRadius: "4px 0",
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "flex-start",
            } },
            React.createElement(MatchCaseOutline, { size: "xs" }))));
};
export const AuthedHeaderAccountMenu = ({ user, content, onClickLogout, open: _open, onOpenChange, }) => {
    const [open, setOpen] = useState(_open);
    useEffect(() => {
        setOpen(_open);
    }, [_open]);
    return (React.createElement(Menu, { open: open, onOpenChange: (open) => {
            setOpen(open);
            onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(open);
        }, placement: "bottom-end", sx: {
            padding: 0,
            gap: 0,
            //@UiDiscrepancy - Figma calls for 67.5 but bumped up to 72 to ensure the default text like "create new organization" does not truncate in the components base state
            maxWidth: 72,
            width: "100%",
        }, content: React.createElement(React.Fragment, null,
            React.createElement(Grid, { container: true, alignItems: "center", gap: 2, sx: { padding: 4 } },
                React.createElement(UserAvatar, { alt: `${user.firstName} ${user.lastName}`, src: user.img, size: "xs" }),
                React.createElement(Grid, { item: true, xs: true },
                    React.createElement(Stack, { width: "100%" },
                        React.createElement(OverflowingTypography, { variant: "body3", fontWeight: "semibold" }, `${user.firstName} ${user.lastName}`),
                        React.createElement(OverflowingTypography, { variant: "body4", textColor: "disabled.onContainer" }, user.email))),
                user.role && user.role.length > 0 && (React.createElement(Tag, { variant: "tonal", color: "primary", density: "dense", sx: {
                        textTransform: "capitalize",
                    } }, user.role))),
            React.createElement(Divider, null),
            React.createElement(Stack, { width: "100%", sx: {
                    maxHeight: "calc(50vh - 112px)",
                    overflow: "auto",
                } }, content),
            React.createElement(Divider, null),
            React.createElement(Box, { sx: {
                    padding: 2,
                }, width: "100%" },
                React.createElement(Button, { variant: "outlined", fullWidth: true, density: "dense", endNode: React.createElement(LogoutOutline, { size: "xs" }), onClick: () => onClickLogout() }, "Log Out"))) },
        React.createElement(AvatarChip, { density: "dense", focused: open, startNode: React.createElement(AvatarGroup, { size: "xxs" },
                React.createElement(CompanyAvatar, { src: user.organizationImg, alt: user.organizationName }),
                React.createElement(UserAvatar, { alt: `${user.firstName} ${user.lastName}`, src: user.img })), endNode: React.createElement(ExpandMoreOutline, { size: "sm", sx: {
                    transform: open ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.1s ease-in-out",
                } }), sx: {
                maxWidth: 40,
            }, slotProps: {
                label: {
                    sx: {
                        breakpoints: {
                            xs: {
                                display: "none",
                            },
                            md: {
                                display: "block",
                            },
                        },
                    },
                },
            } },
            " ",
            user.firstName && user.lastName
                ? `${user.firstName} ${user.lastName}`
                : "-")));
};
//# sourceMappingURL=AuthedHeaderAccountMenu.js.map